<template>
  <div class="flex flex-col group" :class="maxWidth">
    <span v-if="label" class="text-xs text-gray-600 dark:text-gray-400 -mb-1 flex justify-center font-semibold tracking-tight">
      <div class="py-1 px-2 bg-linear-to-b from-white/75 to-white rounded-md rounded-b-none" :class="fluid ? 'w-full text-center' : 'w-fit'">
        {{ label }}
      </div>
    </span>
    <div class="bg-white p-1 rounded-md shadow-sm">
      <!-- Dynamic row layout -->
      <div class="flex flex-col gap-1 text-xs font-semibold">
        <div
          v-for="(rowOptions, rowIndex) in optionRows"
          :key="rowIndex"
          class="grid grid-flow-col auto-cols-fr gap-x-1 gap-y-1"
        >
          <span
            v-for="option in rowOptions"
            :key="option.value"
            class="cursor-pointer transition-colors duration-150 whitespace-nowrap px-2 py-0.5 rounded-sm text-center after:content-[attr(data-label)] after:font-bold after:block after:h-0 after:overflow-hidden after:invisible group-hover:opacity-100"
            :class="{
              'text-white font-bold bg-primary-500': isSelected(option),
              'text-primary-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 bg-primary-100 opacity-70': !isSelected(option),
            }"
            :data-testid="'chip-' + option.value"
            :data-label="option.label"
            @click="toggle(option)"
          >
            {{ option.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: '',
  },
  allLabel: {
    type: String,
    default: 'All',
  },
  rows: {
    type: Number,
    default: 2,
  },
  maxWidth: {
    type: String,
    default: 'max-w-88',
  },
  fluid: {
    type: Boolean,
    default: false,
  },
})

const model = defineModel({
  type: Array,
  default: () => [],
})

const isSelected = option => model.value?.some(o => o.value === option.value)

const toggle = option => {
  if (isSelected(option)) {
    model.value = model.value.filter(o => o.value !== option.value)
  } else {
    model.value = [...model.value, option]
  }
}

const clearSelection = () => {
  model.value = []
}

const optionRows = computed(() => {
  if (props.rows === 1) return [props.options]
  const mid = Math.ceil(props.options.length / props.rows)
  return [props.options.slice(0, mid), props.options.slice(mid)]
})
</script>
